export default [
  {
    path: "/ai-camera",
    name: "ai-camera-personnel",
    component: () => import("@/views/ai-camera/PersonnelGallery.vue"),
    meta: {
      authRequired: true,
      permission: "ai-camera.personal-images",
    },
  },
];
